import { RootState } from 'src/store';

import { IPayoutLimit } from './types';

export const selectPayoutLimitsData = (state: RootState): IPayoutLimit[] => state.payoutLimits.data;
export const selectPayoutLimitsLoading = (state: RootState): boolean => state.payoutLimits.isLoading;
export const selectPayoutLimitsLoaded = (state: RootState): boolean => state.payoutLimits.isLoaded;
